import React from "react";

const EditIconV2 = ({
  color = "#7647EE",
  width = 20,
  height = 20,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.5 17.5H17.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74935 11.2499L12.0827 2.91657C12.773 2.22621 13.8924 2.22621 14.5827 2.91657C15.273 3.60693 15.273 4.72621 14.5827 5.41657L6.24935 13.7499L2.91602 14.5832L3.74935 11.2499Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIconV2;
